import React, { useState } from 'react';
import './UiEmojis.css';
import { Search, Image, Trash2, Smile, Coffee, Activity, Flag } from 'lucide-react'; // Example icons for categories

import { emojiList } from './emojiData';

const UiEmojis = ({ onSelect }) => {
    const [activeTab, setActiveTab] = useState('emoji'); // emoji, upload
    const [filter, setFilter] = useState('all');
    const [searchTerm, setSearchTerm] = useState('');

    const handleEmojiClick = (emoji) => {
        if (onSelect) onSelect(emoji.char);
    };

    const handleRemove = () => {
        if (onSelect) onSelect(null); // Return null or special value to remove
    };

    const getFilteredEmojis = () => {
        let emojis = emojiList;

        // 1. Filter by Category
        if (filter !== 'all') {
            emojis = emojis.filter(e => e.category === filter);
        }

        // 2. Filter by Search Term
        if (searchTerm) {
            const term = searchTerm.toLowerCase();
            emojis = emojis.filter(e =>
                e.keywords.toLowerCase().includes(term) ||
                e.char.includes(term)
            );
        }

        return emojis;
    };

    return (
        <div className="ui-emojis-container">
            {/* Header Menu */}
            <div className="ui-emojis-header">
                <button
                    className={`ui-tab ${activeTab === 'emoji' ? 'active' : ''}`}
                    onClick={() => setActiveTab('emoji')}
                >
                    Emojis
                </button>
                <button
                    className={`ui-tab ${activeTab === 'upload' ? 'active' : ''}`}
                    onClick={() => setActiveTab('upload')}
                >
                    Upload
                </button>
                <button className="ui-tab remove" onClick={handleRemove}>
                    Remove
                </button>
            </div>

            {/* Search Bar */}
            <div className="ui-search-container">
                <div className="ui-search-input-wrapper">
                    <Search size={14} color="#666" />
                    <input
                        type="text"
                        className="ui-search-input"
                        placeholder="Search emojis..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
            </div>

            {/* Content Area */}
            <div className="ui-emojis-content">
                {activeTab === 'emoji' ? (
                    <div className="emoji-grid">
                        {getFilteredEmojis().map((emoji, index) => (
                            <button
                                key={index}
                                className="emoji-item"
                                onClick={() => handleEmojiClick(emoji)}
                            >
                                {emoji.char}
                            </button>
                        ))}
                    </div>
                ) : (
                    <div className="upload-area">
                        <Image size={40} color="#666" />
                        <p>Upload functionality coming soon...</p>
                    </div>
                )}
            </div>

            {/* Bottom Filter Menu */}
            <div className="ui-emojis-footer">
                <button
                    className={`filter-btn ${filter === 'all' ? 'active' : ''}`}
                    onClick={() => setFilter('all')}
                    title="All"
                >
                    <Search size={12} />
                </button>
                <button
                    className={`filter-btn ${filter === 'smileys' ? 'active' : ''}`}
                    onClick={() => setFilter('smileys')}
                    title="Smileys"
                >
                    <Smile size={12} />
                </button>
                <button
                    className={`filter-btn ${filter === 'nature' ? 'active' : ''}`}
                    onClick={() => setFilter('nature')}
                    title="Nature"
                >
                    <Coffee size={12} />
                </button>
                <button
                    className={`filter-btn ${filter === 'objects' ? 'active' : ''}`}
                    onClick={() => setFilter('objects')}
                    title="Objects"
                >
                    <Activity size={12} />
                </button>
            </div>
        </div>
    );
};

export default UiEmojis;
